export enum ChatConversationTypeEnum {
  Individual = 0,
  Group = 1
}

export enum ChatMessageTypeEnum {
  Text = 0,
  Image = 1,
  File = 2,
  System = 3,
  Link = 4
}

export interface ChatParticipant {
  userId: string;
  fullName: string;
  profilePictureUrl: string;
  presenceStatus?: number;
  lastSeen?: string | null;
}

export interface ConversationResponse {
  id: number;
  name: string;
  type: ChatConversationTypeEnum;
  lastMessageContent: string;
  lastMessageOn: Date; 
  unreadCount: number;
  participants: ChatParticipant[];
}

export interface InitialMessage {
  content: string;
  messageType: ChatMessageTypeEnum;
}

export interface CreateConversationRequest {
  participantUserIds: string[];
  type: ChatConversationTypeEnum;
  initialMessage?: InitialMessage;
}

export interface ChatMessageResponse {
  id: number;
  conversationId: number;
  senderId: string;
  senderName: string;
  senderProfilePicture?: string;
  content: string; // HTML Content
  chatMessageType: ChatMessageTypeEnum;
  attachmentUrl?: string | null;
  fileName?: string;
  sentAt: Date;
  isMyMessage: boolean;
  
  // NEW PIN PROPERTIES
  isPinned?: boolean;
  pinnedAt?: Date | string | null;
  pinnedByUserId?: string | null;
  pinnedByName?: string | null;
  
  // Client-side only
  isRead?: boolean;
  readAt?: Date | null;
}

export interface SendMessageRequest {
  conversationId: number;
  content: string;
  messageType: ChatMessageTypeEnum;
  attachmentUrl?: string | null;
  file?: File; // For uploading
  metadata?: string | null;
}

// SignalR Event Payloads

export interface UserPresencePayload {
    userId: string;
    presenceStatus: number;
    lastSeen: string | null;
}

export interface TypingNotificationPayload {
    conversationId: string; // Guide says string for events
    userId: string;
}

export interface ReadReceiptPayload {
    conversationId: number;
    messageIds: number[];
    readByUserId: string;
    readAt: Date;
}

// Additional Helper Models
export interface ChatUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  imageUrl?: string | null;
  role: string;
  // Client-side helpers
  presenceStatus?: number;
  lastSeen?: string | null;
}

export interface ChatMediaResponse {
  messageId: number;
  senderName: string;
  attachmentUrl: string;
  fileName: string;
  thumbnailUrl?: string;
  type: ChatMessageTypeEnum;
  metadata?: string;
  sentAt: Date;
}
